import request from "./api/api"
import { user } from "./api/entities";
import { httpGet, httpPost } from "./api/axios_api";
import Constants from "../constants/constants";

export const actions = {
    login: "LOGIN_USER",
    logout: "LOGOUT",
    resetUserState: "RESET_USER_STATE",
    getUserFromToken: "GET_USER_FROM_TOKEN",
    createUser: "CREATE_USER",
    updateUser: "UPDATE_USER",
    listUser: "LIST_USER",
    getUser: "GET_USER",
    keepAlive: "KEEP_ALIVe"
};

export async function editHomePlayer(token, playerID, firstName, lastName, login, password) {
    let url = `${Constants.BACKEND_URL}/edit-home-player/`
    let config = {
        params: {
            player_id: playerID,
            first_name: firstName,
            last_name: lastName,
            login: login,
            password: password
        }
    }
    return httpPost(url, config, token);
}

export async function loginExists(token, login, userId) {
    let url = `${Constants.BACKEND_URL}/user/login-exists/`;
    let config = {
        params: {
            login: login,
            userId: userId,
        }
    };
    return httpGet(url, config, token);
}

export async function activateHomePlayer(token, playerID, firstName, lastName, login, password) {
    let url = `${Constants.BACKEND_URL}/activate-home-player/`
    let config = {
        params: {
            player_id: playerID,
            first_name: firstName,
            last_name: lastName,
            login: login,
            password: password
        }
    }
    return httpPost(url, config, token);
}

export async function addOrganization(token, organizationData) {
    let url = `${Constants.BACKEND_URL}/add-organization`;
    let config = {
        params: {
            organization_name: organizationData.name
        }
    }
    return httpPost(url, config, token);
}

export async function getPersonnel(token, organizationID) {
    let url = `${Constants.BACKEND_URL}/get-personnel/${organizationID}`;
    return httpGet(url, {}, token);
}

export async function getPeers(token, personnelID) {
    let url = `${Constants.BACKEND_URL}/get-peers/${personnelID}`;
    return httpGet(url, {}, token);
}

export async function archivePersonnel(token, personnelID, newOwnerID) {
    let url = `${Constants.BACKEND_URL}/archive-personnel`;
    let config = {
        params: {
            personnel_id: personnelID,
            new_owner_id: newOwnerID
        }
    }
    return httpPost(url, config, token);
}

export async function setPersonnelLockoutStatus(token, personnelID, newStatus) {
    let url = `${Constants.BACKEND_URL}/set-personnel-lockout-status/`;
    let config = {
        params: {
            personnel_id: personnelID,
            lockout_status: newStatus
        }
    }
    return httpPost(url, config, token);
}

export async function editPersonnel(token, personnelID, editData) {
    let url = `${Constants.BACKEND_URL}/edit-personnel/`;
    let config = {
        params: {
            personnel_id: personnelID,
            edit_data: editData
        }
    }
    return httpPost(url, config, token);
}

export async function addPersonnel(token, new_personnel_data) {
    let url = `${Constants.BACKEND_URL}/add-personnel/`;
    let config = {
        params: {
            new_personnel_data: new_personnel_data
        }
    }
    return httpPost(url, config, token);
}

export async function getAllPersonnel(token, organizationID) {
    let url = `${Constants.BACKEND_URL}/get-all-personnel/`;
    return httpGet(url, {}, token);
}

export async function getCircleMembers(token, playerID) {
    let url = `${Constants.BACKEND_URL}/get-circle-members/${playerID}`;
    return httpGet(url, {}, token);
}

export async function editCircleMember(token, playerID, firstName, lastName, email, relationshipToUser, phoneNumber, circleMemberID) {
    let url = `${Constants.BACKEND_URL}/edit-circle-member/`;
    let config = {
        params: {
            player_id: playerID,
            first_name: firstName,
            last_name: lastName,
            email: email,
            phone_number: phoneNumber,
            relationship_to_user: relationshipToUser,
            circle_member_id: circleMemberID
        }
    }
    return httpPost(url, config, token);
}

export async function addCircleMember(token, playerID, firstName, lastName, email, relationshipToUser, phoneNumber) {
    let url = `${Constants.BACKEND_URL}/add-circle-member/`
    let config = {
        params: {
            player_id: playerID,
            first_name: firstName,
            last_name: lastName,
            email: email,
            phone_number: phoneNumber,
            relationship_to_user: relationshipToUser
        }
    }
    return httpPost(url, config, token);
}

export async function getUserOrganizations(token) {
    let url = `${Constants.BACKEND_URL}/get-user-organizations`;
    return httpGet(url, {}, token);
}

export async function getTeamMembers(token, showAll) {
    if (typeof showAll === "undefined") {
        showAll = false
    }
    let url = `${Constants.BACKEND_URL}/get-team-members/${showAll}`;
    return httpGet(url, {}, token);
}

export async function getRoles(token) {
    let url = `${Constants.BACKEND_URL}/get-roles/`;
    return httpGet(url, {}, token);
}

export async function getTeamMember(token, teamMemberID) {
    let url = `${Constants.BACKEND_URL}/get-team-member/` + teamMemberID;
    return httpGet(url, {}, token);
}

export async function updateTeamMember(teamMemberData, token) {
    let url = `${Constants.BACKEND_URL}/update-team-member/`
    let newPassword = teamMemberData.newPassword;

    if (newPassword === "") {
        newPassword = false;
    }

    let config = {
        params: {
            team_member_id: teamMemberData.id,
            email: teamMemberData.email,
            first_name: teamMemberData.firstName,
            last_name: teamMemberData.lastName,
            login: teamMemberData.login,
            new_password: newPassword
        }
    }
    return httpPost(url, config, token);
}

export async function loginAsync(email, password) {
    let config = {
        params: {
            email: email,
            password: password
        }
    };
    let url = `${Constants.BACKEND_URL}/login`;
    return httpPost(url, config, "");
}

export function keepAlive(token) {
    return dispatch => {
        let url = `${Constants.BACKEND_URL}/keep-alive`;
        httpPost(url, {}, token).then((response) => {
            if (response.data.success) {
                dispatch({
                    type: actions.keepAlive
                })
            }
            else {
                //TODO: handle results load error
            }
        })
    }
}

export function login(email, password) {
    const payload = {
        params: {
            email: email,
            password: password
        }
    };
    return request(actions.login, "/login", "POST", payload, []);
}

export function logout() {
    var payload = {};
    httpPost(process.env.REACT_APP_API_SERVER + "/logout", payload);
}

export function resetUserState() {
    return { type: actions.resetUserState }
}

export function getUserFromToken() {
    return request(actions.getUserFromToken, "/userFromToken", "POST", {}, []);
}

export function createUser(userObject) {
    return user.create(actions.createUser, userObject, []);
}

export function updateUser(userId, userObject) {
    return user.update(actions.updateUser, userId, userObject, []);
}

export function getUsers(query, sort) {
    return user.list(actions.listUser, query, sort);
}

export function getUser(userId) {
    return user.get(actions.getUser, userId, []);
}

const INITIAL_STATE = {
    token: "",
    users: [],
    user: {}
};

export default function reducer(state = INITIAL_STATE, action) {
    if (action.headers && action.headers.new_auth) {
        setAuthToken(action.headers.new_auth);
    }

    switch (action.type) {
        case actions.login:
        case actions.getUserFromToken: {
            if (action.body) {
                setAuthToken(action.body.token)
            }

            const isSuperRole = action.body && action.body.role
                ? action.body.role.toLowerCase() === Constants.SUPER_ROLE
                : false;

            const isAdminRole = isSuperRole
                || (action.body && action.body.role
                    ? action.body.role.toLowerCase() === Constants.ADMIN_ROLE
                    : false);

            const isTherapistRole = isAdminRole
                || (action.body && action.body.role
                    ? action.body.role.toLowerCase() === Constants.THERAPIST_ROLE
                    : false);
            const is_impersonated = action.body ? action.body.is_impersonated : false;

            return {
                ...state,
                token: action.body ? action.body.token : state.token,
                currentUserId: action.body ? action.body.userId : null,
                currentUserFirstName: action.body ? action.body.userFirstName : null,
                currentUserLastName: action.body ? action.body.last_name : null,
                role: action.body ? action.body.role : null,
                roleLevel: action.body ? action.body.roleLevel : null,
                limited: action.body ? action.body.limited : null,
                isSuperRole: isSuperRole,
                isAdminRole: isAdminRole,
                isTherapistRole: isTherapistRole,
                organization: action.body ? action.body.organization : null,
                isMasquaraded: is_impersonated
            }
        }
        case actions.resetUserState: {
            return {
                ...state,
                user: {}
            };
        }
        case actions.createUser:
            return {
                ...state,
                users: action.body ? typeof (state.users) !== "undefined" ? [...state.users, action.payload] : [action.payload] : state.users
            };
        case actions.listUser:
            return {
                ...state,
                users: action.body ? action.body._items : state.users
            };
        case actions.getUser:
            return {
                ...state,
                user: action.body ? action.body : state.user
            };
        case actions.updateUser:
            return {
                ...state,
                id: action.body ? action.body : null
            };
        case actions.keepAlive:
            return {
                ...state
            };
        default:
            return {
                ...state
            };
    }
}

export function setAuthToken(value) {
    localStorage.setItem("timocco.auth", value);
}



// WEBPACK FOOTER //
// ./src/modules/user.js